import { render } from "./HeaderBack.vue?vue&type=template&id=6abbfc35"
import script from "./HeaderBack.vue?vue&type=script&lang=js"
export * from "./HeaderBack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__